export default "__VITE_ASSET__Co6kUasp__"